import React, { useEffect, useState } from "react";
import { IFilterCategory } from "../../../../types/category.type";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";
import FilterSelectApi from "../FilterSelectApi";

function FilterDMBAN({ setCondition }: IFilterCategory) {
  const originFilter: { [key: string]: any } = {
    ban: "",
    kho: null,
    nhom_ban: null,
    trang_thai: null,
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = { $or: [] };
    if (filter.ban) {
      condition.$or.push({
        ma_ban: { $regex: filter.ban?.split(" ")?.join(".*"), $options: "i" },
      });
      condition.$or.push({
        ten_ban: {
          $regex: filter.ban?.split(" ")?.join(".*"),
          $options: "i",
        },
      });
    }
    if (filter.kho) {
      condition.ma_kho = filter.kho?.ma_kho;
    }
    if (filter.nhom_ban) {
      condition.nh_ban = filter.nhom_ban._id;
    }
    if (filter.trang_thai) {
      condition.trang_thai = filter.trang_thai?.ma_trang_thai;
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        direction="column"
        label="Mã, tên bàn"
        placeholder="Tìm theo mã, tên bàn"
        value={filter.ban}
        onSearch={(val) => setFilter({ ...filter, ban: val })}
      />
      <FilterSelectApi
        direction="column"
        label="Chi nhánh"
        placeholder="Chọn chi nhánh"
        apiCode="dmkho"
        searchFields={["ma_kho", "ten_kho"]}
        getOptionLabel={(option) => option.ten_kho}
        checkEqual={(value, option) => value?.ma_kho === option?.ma_kho}
        value={filter.kho}
        onChange={(val) => setFilter({ ...filter, kho: val })}
      />
      <FilterSelectApi
        direction="column"
        label="Khu vực bàn"
        placeholder="Chọn khu vực bàn"
        apiCode="group"
        searchFields={["group_name"]}
        defaultCondition={{ group_type: "TABLE" }}
        getOptionLabel={(option) => option.group_name}
        checkEqual={(value, option) => value?._id === option?._id}
        value={filter.nhom_ban}
        onChange={(val) => setFilter({ ...filter, nhom_ban: val })}
      />
      <FilterSelectApi
        direction="column"
        label="Trạng thái"
        placeholder="Chọn trạng thái"
        apiCode="trangthai"
        searchFields={["ma_trang_thai", "ten_trang_thai"]}
        defaultCondition={{ ma_ct: "DMBAN" }}
        withIdApp={false}
        getOptionLabel={(option) =>
          option.ten_trang_thai || option.ma_trang_thai
        }
        checkEqual={(value, option) =>
          value?.ma_trang_thai === option?.ma_trang_thai
        }
        value={filter.trang_thai}
        onChange={(val) => setFilter({ ...filter, trang_thai: val })}
      />
    </WrapperFilter>
  );
}

export default FilterDMBAN;
